var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3Overheating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 58a4.999 4.999 0 11-7-4.58V35h4v18.42A5 5 0 0125 58zm4-9.38a13 13 0 11-18 0V7h18v41.62zm-.4 6.66a8.94 8.94 0 00-3-4.3l-.6-.52V29h-7v-4h7v-4h-7v-4h7v-6H15v39.46l-.73.6A9.08 9.08 0 0011.89 62a8.55 8.55 0 005 4.47A9 9 0 0028.6 55.28zm35.85-25.51a7 7 0 01-3.68 5.68c1.15-10.55-3.55-17.54-10.49-19.6C53.67 29.09 39.48 31 38.63 42.38 38 51.2 44.25 54.63 51.41 55.61c-2.87-1.21-5.57-4.06-5.87-7.18-.54-6.22 6.46-6.67 7.81-11.16a7.11 7.11 0 01-.67 9.26A8.78 8.78 0 0058.86 42c3.87 2.83 4.18 10.46-.37 13.34 13.06-4.34 13.7-17.66 5.96-25.57z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Overheating.41ba5637.svg";
export { SvgB3Overheating as ReactComponent };